import React, { useState } from "react";
import { t } from "i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ConfirmDialog from "components/Custom/Dialogs/ConfirmDialog";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import Close from "@mui/icons-material/Close";

const FileDisplay = ({ fileState, onDelete, onUploadClick, disabled }) => {
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	const handleDeleteClick = () => {
		if (!disabled) {
			setDeleteDialogOpen(true);
		}
	};

	const handleDeleteConfirm = () => {
		setDeleteDialogOpen(false);
		onDelete(fileState);
	};

	const handleDeleteCancel = () => {
		setDeleteDialogOpen(false);
	};

	const renderUploadStatusIcon = () => {
		return <InsertDriveFile sx={{ mr: 1, color: "primary.main" }} />;
	};

	return (
		<>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					border: "1px solid",
					borderColor: "grey.300",
					borderRadius: 2,
					p: 1,
					maxWidth: 300,
					bgcolor: "grey.50",
					mt: 2,
					opacity: disabled ? 0.6 : 1 // Visual feedback for disabled state
				}}
			>
				{renderUploadStatusIcon()}
				<Typography
					variant="body2"
					sx={{
						flexGrow: 1,
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						cursor: "pointer"
					}}
					onClick={disabled ? null : onUploadClick}
				>
					{fileState?.name || t("SOURCES.FILES.unknownFile")}
				</Typography>
				<Tooltip title={t("SOURCES.FILES.deleteTooltip")}>
					<span>
						<IconButton size="small" onClick={handleDeleteClick} disabled={disabled}>
							<Close fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			</Box>

			{deleteDialogOpen && (
				<ConfirmDialog
					title={t("SOURCES.FILES.deleteWarningTitle")}
					content={t("SOURCES.FILES.deleteWarningMessage", {
						defaultValue:
							"Attention : Si vous supprimez ce fichier, il sera définitivement supprimé du cloud. Cette action est irréversible, même si vous annulez la modification de l'asset par la suite."
					})}
					open
					handleClose={handleDeleteCancel}
					handleConfirm={handleDeleteConfirm}
					isDelete
				/>
			)}
		</>
	);
};

export default FileDisplay;
